module.exports = __webpack_public_path__ + "officialStatic/img/productBg.781e738.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/productBg.png
// module id = epDb
// module chunks = 0